import React from 'react'
import { Form, Input } from '@surecompanies/core_components'
import { FieldGroup } from '../../PaymentDetailModal/PaymentDetailModal.styles'
import {
  StatusUpdateFormKey,
  StatusUpdateFormKeyLabels,
} from '../statusUpdate.type'

export function TicketField() {
  return (
    <FieldGroup>
      <Form.Item
        name={StatusUpdateFormKey.TICKET}
        label={StatusUpdateFormKeyLabels[StatusUpdateFormKey.TICKET]}
        rules={[
          {
            required: true,
            message: `${StatusUpdateFormKeyLabels[StatusUpdateFormKey.TICKET]} is required`,
          },
        ]}
        style={{ marginBottom: 0 }}
      >
        <Input placeholder="Enter ticket" style={{ width: '100%' }} />
      </Form.Item>
    </FieldGroup>
  )
}
